import { Container, Grid, Typography, Paper, Button, Badge, Stack, Box } from "@mui/material"
import globals from "../../globals"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import CourseCarousel from "../../components/carousels/courseCarousel"

const competitions = [
    {
        "id": 1,
        "img_front": 'konkurs.png',
        "active": false,
    },
    // {
    //     "id": 2,
    //     "img_front": 'hristo.webp',
    //     "active": false,
    // },
    // {
    //     "id": 3,
    //     "img_front": 'hristo.webp',
    //     "active": false,
    // },
    // {
    //     "id": 4,
    //     "img_front": 'hristo.webp',
    //     "active": false,
    // }
]

const CompetitionsPage = () => {

    const navigate = useNavigate();
    const [suggestedCourses, setSuggestedCourses] = useState([]);


    useEffect(() => {
        fetch(globals.apiUrl + '/courses/suggested', {
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                //console.log('data', data)
                setSuggestedCourses(data);
            });
    }, []);

    return (
        <Container sx={{ mb: 3 }}>
            <Grid container justifyContent={'center'} direction={'column'} textAlign={'center'}>
                <Grid item>
                    <img src="competitions.png" style={{ height: 300, width: 'auto' }} />
                </Grid>
                <Grid item>
                    <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 25 }}>Конкурси</Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 20, mt: 2 }}>Тук ще откриеш разнообразие от конкурси,
                        предлагани от eAcademiaBg</Typography>
                </Grid>
            </Grid>

            <Grid container justifyContent={'center'} rowSpacing={{ xs: 2, sm: 0 }}>
                {competitions.map((competition) => (
                    <Grid item key={competition.id} xs={12} sm={4} display="flex" justifyContent="center" sx={{ mt: 5 }}>
                        <a href='/competition'><Paper elevation={3} sx={{
                            width: 270,
                            borderRadius: 1,
                            overflow: 'hidden',
                            textAlign: "center",
                        }}>
                            <img src={competition.img_front} style={{ width: '100%', height: 'auto', display: 'block' }} alt={competition.id} />
                            <Badge badgeContent={(competition.active) ? 'активен' : 'неактивен'} color={(competition.active) ? 'success' : 'error'} >
                                <Button sx={{ textTransform: 'none', fontSize: 17, color: globals.colors.lightRed, '&:hover': { backgroundColor: 'transparent', color: globals.colors.lightRed } }}>Прочети повече</Button>
                            </Badge>
                        </Paper></a>
                    </Grid>
                ))}
            </Grid>

                {suggestedCourses.length > 0 &&
                    <Grid container justifyContent='space-evenly' justifyItems={'center'} textAlign={'center'}>
                        <Stack>
                            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Typography sx={{color: globals.colors.lightRed, fontWeight:'bold', fontSize: 23, mt:10, mb:3}}>Разгледай курсовете, които предлагаме</Typography>
                            </Grid>
                            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <CourseCarousel courses={suggestedCourses} />
                            </Grid>
                        </Stack>
                    </Grid>
                }
        </Container>
    )
}

export default CompetitionsPage